import React from "react"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import { getStaticImage } from "utils/statics"
import { getChannelName, getChannelTitle } from 'utils/channelsUtils'
import { I18n } from "react-redux-i18n"
import _clonedeep from 'lodash.clonedeep'

/**
 * @param {object} props
 * @param {object} props.channel
 */
const ChannelItem = (props) => {
  const {
    channel: {
      name, channel, provider, connectionType, botName,
      value, botNameIG, brandName, delegationName
    }
  } = props

  const channelName = getChannelName([{
    channel, provider, connectionType
  }])

  const title = getChannelTitle({ name, botName, value, botNameIG })
  let info = brandName || ''
  if (delegationName) {
    info += `${info ? ' ' : ''}${delegationName}`
  }

  return (
    <div className="operator_channel-priority-item">
      <div className="operator_channel-priority-item_image">
        <img
          src={getStaticImage(`/channels/${channelName}-icon.svg`)}
          alt={`${channel} Channel`}
          onError={(event) => {
            event.target.src = getStaticImage('/default-picture.png')
            event.onerror = null
          }}
        />
      </div>
      <div className="operator_channel-priority-item_content">
        <div className="operator_channel-priority-item_content-title">
          {title}
        </div>
        <div className="operator_channel-priority-item_content-info">
          {info}
        </div>
      </div>
    </div>
  )
}

/**
 * Sort and select channel priority
 * @param {object} props
 * @param {[object]} props.channels
 * @param {[object]} props.channelsPriority
 * @param {function} props.onChange
 */
const ChannelPriorityList = (props) => {
  const { channels, channelsPriority, onChange } = props

  const handleOnDragEnd = (result) => {
    if (!result) return

    const { destination, source } = result
    if (!destination) return

    const sourceId = source?.droppableId
    const sourceIdx = source?.index

    const destinationId = destination?.droppableId
    const destionationIdx = destination?.index

    // No ha cambiado nada
    if (destinationId === sourceId && destionationIdx === sourceIdx) return

    // Si cambia posición en la misma lista
    if (destinationId === sourceId && destionationIdx !== sourceIdx) {
      if (destinationId === 'priority') {
        const chs = _clonedeep(channelsPriority)
        const aChannel = chs.splice(sourceIdx, 1)
        chs.splice(destionationIdx, 0, aChannel[0])

        onChange({
          channelsPriority: chs
        })

        return
      }

      if (destinationId === 'list') {
        const chs = _clonedeep(channels)
        const aChannel = chs.splice(sourceIdx, 1)
        chs.splice(destionationIdx, 0, aChannel[0])

        onChange({
          channels: chs
        })

        return
      }
    }

    // Cambio de lista a priority
    if (destinationId === 'priority') {
      const chs = _clonedeep(channels)
      const chPrioritys = _clonedeep(channelsPriority)

      const aChannel = chs.splice(sourceIdx, 1)
      chPrioritys.splice(destionationIdx, 0, aChannel[0])

      onChange({
        channels: chs,
        channelsPriority: chPrioritys
      })

      return
    }

    // Cambio de lista a list
    if (destinationId === 'list') {
      const chPrioritys = _clonedeep(channelsPriority)
      const chs = _clonedeep(channels)

      const aChannel = chPrioritys.splice(sourceIdx, 1)
      chs.splice(destionationIdx, 0, aChannel[0])

      onChange({
        channels: chs,
        channelsPriority: chPrioritys
      })

      return
    }
  }

  return (
    <div className="operator_channel-priority-container">
      <DragDropContext
        onDragEnd={handleOnDragEnd}
      >
        <Droppable
          droppableId="priority"
          direction="vertical"
          type='column'
        >
          {(p) => (
            <div
              {...p.droppableProps}
              ref={p.innerRef}
              className="operator_channel-priority-list"
            >
              <p className="operator_channel-priority-list-title">
                {I18n.t('operator_channel_priority_title')}
              </p>
              <div
                className="operator_channel-priority-list-drag"
              >
                {
                  channelsPriority.map((ch, idx) => (
                    <Draggable
                      key={ch.id}
                      draggableId={ch.id}
                      index={idx}
                    >
                      {provided_d => (
                        <div
                          {...provided_d.draggableProps}
                          {...provided_d.dragHandleProps}
                          id={`channel-${ch.id}`}
                          ref={provided_d.innerRef}
                          className="operator_channel-priority-item-drag"
                        >
                          <ChannelItem
                            channel={ch}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))
                }
                {p.placeholder}
              </div>
            </div>
          )}
        </Droppable>
        <Droppable
          droppableId="list"
          direction="vertical"
          type='column'
        >
          {(p) => (
            <div
              {...p.droppableProps}
              ref={p.innerRef}
              className="operator_channel-priority-list"
            >
              <p className="operator_channel-priority-list-title">
                {I18n.t('operator_channel_available_title')}
              </p>
              <div
                className="operator_channel-priority-list-drag"
              >
                {
                  channels.map((ch, idx) => (
                    <Draggable
                      key={ch.id}
                      draggableId={ch.id}
                      index={idx}
                    >
                      {provided_d => (
                        <div
                          {...provided_d.draggableProps}
                          {...provided_d.dragHandleProps}
                          id={`channel-${ch.id}`}
                          ref={provided_d.innerRef}
                          className="operator_channel-priority-item-drag"
                        >
                          <ChannelItem
                            channel={ch}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))
                }
                {p.placeholder}
              </div>
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  )
}

export default ChannelPriorityList